import FontFaceObserver from 'fontfaceobserver';

export default class FontFace {
  constructor() {
    const quicksandObserver = new FontFaceObserver('Quicksand');
    const bryantObserver = new FontFaceObserver('Bryant');
    const naosObserver = new FontFaceObserver('Naos');

    Promise.all([
      quicksandObserver.load(),
      bryantObserver.load(),
      naosObserver.load(),
    ]).then(() => {
      document.body.classList.add('font-loaded');
    });
  }
}
